"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_LIBRARY_LOAD_RETRY_LIMIT = exports.TRACKING_LIBRARY_LOAD_INTERVAL = exports.GTM_DATALAYER_WINDOW_KEY = exports.GCP_TREE_PREFIXES = void 0;
var _process, _process2;
var TRACKING_LIBRARY_LOAD_INTERVAL = 100;
exports.TRACKING_LIBRARY_LOAD_INTERVAL = TRACKING_LIBRARY_LOAD_INTERVAL;
var TRACKING_LIBRARY_LOAD_RETRY_LIMIT = 200;
exports.TRACKING_LIBRARY_LOAD_RETRY_LIMIT = TRACKING_LIBRARY_LOAD_RETRY_LIMIT;
var GTM_DATALAYER_WINDOW_KEY = ((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_APP_GTM_DATALAYER_WINDOW_KEY) || ((_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.GTM_DATALAYER_WINDOW_KEY) || 'gtmDataLayer';
exports.GTM_DATALAYER_WINDOW_KEY = GTM_DATALAYER_WINDOW_KEY;
var GCP_TREE_PREFIXES = {
  CATEGORY: 'C',
  GROUPING: 'G',
  PERFORMER: 'P'
};
exports.GCP_TREE_PREFIXES = GCP_TREE_PREFIXES;